export default __webpack_public_path__ + "static/media/main3_xl.6772fe81.jpg";